export default __webpack_public_path__ + "static/media/boite7.0ac9edb0.jpg";